var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 125,
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.14 0C88.99 0 114 25.072 114 56s-25.01 56-55.86 56C27.29 112 2.28 86.928 2.28 56S27.29 0 58.14 0Zm.656 23.573c-17.798 0-32.226 14.464-32.226 32.307 0 17.843 14.428 32.308 32.226 32.308 17.799 0 32.227-14.465 32.227-32.308S76.595 23.573 58.796 23.573Z",
    id: "c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#b)",
    d: "M0 0h235v125H0z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55 5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#798896",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)",
    stroke: "#FFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC000",
    d: "m57.542-8.556.977 64.175 68.4-6.858L104.9-4.612z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E7899",
    d: "m59.28 55.619 84.073-16.584-29.111 84.72-73.962 14.169z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#485159",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M91.58 29.333 112 9M.38 92.571l18.382-18.428M90.06 91.048 104 102"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M18 100h37v13H18zm141 10h37v13h-37zM169 5h37v13h-37z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.d96286ee2eb306d45265c8d16aa77d7a.svg";
export { ForwardRef as ReactComponent };